import { Config, FunnelType } from 'scenes/common/types';

export const getConfigState = (state: { config: Config }) => state.config;

export const getMaintenanceStatus = (state: { config: Config }) => {
  if (getConfigState(state).productsUnderMaintenance.length > 0) {
    return (
      getConfigState(state).productsUnderMaintenance.includes(
        FunnelType.Payment
      ) && getConfigState(state).underMaintenance
    );
  }
  return getConfigState(state).underMaintenance;
};
